/* eslint-disable tailwindcss/enforces-shorthand */
/* eslint-disable jsx-a11y/alt-text */
import { FaYoutube } from "react-icons/fa";
import { YouTubeEmbed } from "@next/third-parties/google";
import { ComponentSetting } from "./component-interfaces";

const regexVideoId = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;

export function VideoComponent({ data }: { data: ComponentSetting['videoConfig'] | null }) {
  const youtubeVideoId = data?.link.match(regexVideoId);

  return (
    <div>
      {!!data?.title && <div className="mb-1 ml-2 mt-2 font-semibold">{data?.title}</div>}
      {!!data?.link
        ? (
          <div className="w-full aspect-video overflow-hidden relative">
            {youtubeVideoId?.[1] && (
              <YouTubeEmbed videoid={youtubeVideoId[1]} />
            )}
            {!youtubeVideoId?.[1] && (
              <video width="480" height="320" controls preload="none">
                <source src={data.link} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        )
        : (
          <div className="bg-gray-100 w-full aspect-video overflow-hidden relative">
            <div className="h-full flex flex-row justify-center items-center">
              <FaYoutube size={60} className="opacity-50" />
            </div>
            <img src="/images/default_image_banner.svg" className="w-full absolute bottom-0 left-0 right-0" />
          </div>
        )
      }
    </div>
  )
}